import React from "react";
import Proptypes from "prop-types";

import { CtaButton } from "../../Elements";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
import { ResourcesCTAWrapper } from "./style";

const ResourcesWithCTA = (props) => {
	const { header, cta, resourceData, context = {} } = props;
	const { globalHostName } = context;

	return (
		<ResourcesCTAWrapper>
			<div className="header">{header}</div>
			<div className="resourcesWrapper">
				{resourceData.map((resource, index) => (
					<div key={index} className="container">
						<a
							href={
								globalHostName
									? globalHostName + "/" + resource?.resourceFullSlug
									: resource?.resourceSlug
							}
						>
							<div className="image">
								<CloudinaryImage lazyload url={resource?.resourceImageUrl} />
							</div>
							<div className="text">
								<div className="heading">{resource?.resourceHeading}</div>
								<div className="description">{resource?.resourceContent}</div>
							</div>
						</a>
					</div>
				))}
			</div>
			<div className="buttonWrapper">
				<CtaButton cta={cta} />
			</div>
		</ResourcesCTAWrapper>
	);
};

ResourcesWithCTA.propTypes = {
	header: Proptypes.string,
	resourceData: Proptypes.array,
	cta: Proptypes.shape({
		link: Proptypes.shape({
			type: Proptypes.oneOf(["hash", "external", "internal"]),
			value: Proptypes.string,
		}),
		color: Proptypes.string,
		type: Proptypes.oneOf(["solid", "outline"]),
		text: Proptypes.string,
	}),
};

ResourcesWithCTA.defaultProps = {
	header: "",
	resourceData: [],
	cta: null,
};

export default ResourcesWithCTA;
